import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 155px;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme }) => theme.defaultColors.grey};
  box-shadow: none;
  display: block;
  font-size: 16px;
  padding: 14px;
  outline: none;
  resize: none;
  margin-top: 20px;

  ${media.md`
    font-size: 14px;
  `}
`;

export const TextAreaLabel = styled.label`
  font-weight: 600;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  width: 100%;
  font-size: 15px;
  ${media.md`
    font-size: 16px;
  `}
`;
